import React, { useEffect } from "react";
import { BackIcon, Container, DetailView, SkillCircle } from "./styles";
import { useDispatch, useSelector } from "react-redux";
import { BoldHeading, HorizontalLeftAlign, RegLg } from "../../../../Components/CustomStyles";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import UserListComponent from "../../../../Components/UserListComponent";

const CourseRequests = ({ handleView, course }) => {
  let { enrollReqList } = useSelector((state) => state.home);
  return (
    <Container>
      <HorizontalLeftAlign style={{ marginTop: 10, marginBottom: 10 }}>
        <BackIcon onClick={() => handleView('details', course)} >
          <KeyboardBackspaceIcon style={{ marginBottom: -8 }} />
        </BackIcon>
        <BoldHeading style={{ textTransform: 'capitalize' }} >{course?.title}</BoldHeading>
      </HorizontalLeftAlign>
      <UserListComponent title={"Requests"} list={enrollReqList} reqList={enrollReqList} course={course} />
    </Container>
  );
};

export default CourseRequests;
